<script>

import Vue from 'vue';
const nprogress = require('nprogress');
const config = require('@/config.js')[ process.env.NODE_ENV || 'development' ]
import movable from 'v-movable';
Vue.use(movable);

export default {
    data () {
        return {
            loading      : true,
            document_url : null,
            qrcode_url   : null,
            qrcode_coordinates : null,
            qrcode_side  : 150,
            generating   : false,
        }
    },
    mounted () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            nprogress.done(true);
        })
    },
    watch: {
        getted( newval, oldval ) {
            if ( newval === true && oldval === false ) {
                this.document_url = config.backend_url + this.obj.config.cover.url;
                this.qrcode_url   = config.backend_url + this.obj.config.qrcode.url;
                this.loading      = false;
            }
        },
        setted( newval, oldval ) {
            if ( newval === true && oldval === false ) {
                this.$store.dispatch('item/force_reload');
                this.$router.push( 'list/item' );
            }
        },
    },
    computed: {
        getted() { return this.$store.state.item.getted; },
        setted() { return this.$store.state.item.setted; },
        obj() { return this.$store.state.item.obj; },
    },
    created () {
        this.$store.dispatch('item/get_by_id', { id: this.$route.params.id, include: false } );
    },
    methods: {
        set_qrcode_position( obj ) {
            this.qrcode_coordinates = {
                left : obj.gridCss.left,
                top  : obj.gridCss.top,
            };
        },
        get_cover_dimensions() {
            return { cover_height: this.$refs.cover.clientHeight, cover_width: this.$refs.cover.clientWidth };
        },
        send_data() {
            this.generating = true;
            var payload = {
                cover           : this.get_cover_dimensions(),
                qrcode_side     : this.qrcode_side,
                qrcode_position : this.qrcode_coordinates,
            };
            this.$store.dispatch('item/set_qrcode_position', payload );
        }
    },
    components: {
    }
};

</script>

<template>
 
    <div>
        <div style="margin-bottom: 20px">
            <b-button :disabled="generating" variant="success" @click="send_data">Salva impostazioni</b-button>
        </div>
        <div v-if="loading === false">
            <b-img :src="document_url" ref="cover" alt="Responsive image" style="border: 1px solid grey; position: absolute; width: 90%; margin: auto"></b-img>
            <div style="position: relative;">
                <movable posTop="0" posLeft="0" class="testmove" ref="parentEl" style="color: white; height: 150px; width: 150px;" @complete="set_qrcode_position">
                    <b-img :src="qrcode_url" fluid alt="Responsive image" style=""></b-img>
                </movable>
            </div>
        </div>
    </div>

</template>

<style>
    .testmove {
      display:block;
      position: absolute;
      top: 0;
      background: #333;
      color: white;
      border: 2px solid red;
    }
    .modaltitle {
      background: blue;
      display:block;
      width:100%;
      color: white;
    }
</style>

